import { useContext } from 'react';
import { PRContext } from '../contexts/ProcurementParamsContext';

export const usePRContext = () => {
  const context = useContext(PRContext);
  if (!context) {
    throw new Error(
      'usePRContext must be used within a ProcurementParamsContextProvider'
    );
  }
  return context;
};
